import { render } from "./Area.vue?vue&type=template&id=31c9bc77&scoped=true"
import script from "./Area.vue?vue&type=script&lang=js"
export * from "./Area.vue?vue&type=script&lang=js"

import "./Area.vue?vue&type=style&index=0&id=31c9bc77&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31c9bc77"

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
